module.exports = __webpack_public_path__ + "media/Components/fonts/boldTeko-ff817333802ca240623cef0c06ffa3ce.ttf";